var gbs = {
	//host: '/slsAdminApi', // 接口根地址。本地代理到slsadmin.api.sls.com,线上使用的是Nginx代理
	host: 'https://www.fuluonong.com/19402/public/index.php/api/v1/',
	db_prefix: 'solely', // 本地存储的key
	// 状态码字段
	api_status_key_field: 'solely_code',
	// 状态码value
	api_status_value_field: 100000,
	// 存放数据的字段
	api_data_field: '',
	api_custom: {
		404: function(res) {
			this.$store.dispatch('remove_userinfo').then(() => {
				this.$alert(res.status + ',' + res.msg + '！', '登录错误', {
					confirmButtonText: '确定',
					callback: action => {
						this.$router.push('/login')
					}
				})
			})
		}
	},
	menu: [{
			id: '0',
			name: '控制面板',
			icon: 'el-icon-s-platform',
			router: '/home/dashboard',
			button: ['添加', '添加任务', '编辑任务'],
			hasButton: [],
			isShow: true,
			parent: '0'
		},
		{
			id: '20',
			name: '设置',
			icon: 'el-icon-s-tools',
			isShow: true,
			children: [{
					id: '200',
					name: '管理员列表',
					router: '/home/adminLists',
					icon: 'reorder',
					isShow: true,
					button: ['编辑账号', '管理权限', '添加账号', '删除选中', '编辑信息', '添加信息'],
					hasButton: [],
					parent: '20'
				},
				{
					id: '201',
					name: '项目配置',
					router: '/home/config',
					icon: 'reorder',
					isShow: true,
					button: ['编辑', '添加', '删除选中'],
					hasButton: [],
					parent: '20'
				},
				{
					id: '202',
					name: '平台管理',
					router: '/home/thirdApp',
					icon: 'reorder',
					isShow: true,
					button: ['编辑', '添加', '删除选中'],
					hasButton: [],
					parent: '20'
				},
				{
					id: '202',
					name: '权限管理',
					router: '/home/access',
					icon: 'reorder',
					isShow: false,
					button: ['返回', '权限全选', '更新权限'],
					hasButton: [],
					parent: '20'
				},
				{
					id: '203',
					name: '角色管理',
					router: '/home/role',
					icon: 'reorder',
					isShow: true,
					button: ['编辑', '添加', '删除选中', '管理权限'],
					hasButton: [],
					parent: '20'
				},
			]
		},
		{
			id: '1',
			name: '用户管理',
			icon: 'el-icon-user-solid',
			isShow: true,
			children: [
				{
					id: '11',
					name: '用户管理',
					router: '/home/user',
					icon: 'reorder',
					isShow: true,
					button: ['编辑账号', '添加账号', '删除选中', '编辑信息', '添加信息','导出'],
					hasButton: [],
					parent: '1'
				}
			]
		},
		{
			id: '2',
			name: '内容管理',
			icon: 'el-icon-s-unfold',
			isShow: true,
			children: [{
					id: '21',
					name: '文章菜单管理',
					router: '/home/label',
					icon: 'reorder',
					isShow: true,
					button: ['编辑', '删除选中', '添加'],
					hasButton: [],
					parent: '2'
				},
				{
					id: '22',
					name: '文章管理',
					router: '/home/article',
					icon: 'reorder',
					isShow: true,
					button: ['编辑', '删除选中', '添加'],
					hasButton: [],
					parent: '2'
				},
				{
					id: '23',
					name: '首页轮播',
					router: '/home/banner',
					icon: 'reorder',
					isShow: true,
					button: ['编辑', '删除选中', '添加'],
					hasButton: [],
					parent: '2'
				},
				{
					id: '24',
					name: '公告管理',
					router: '/home/notice',
					icon: 'reorder',
					isShow: true,
					button: ['编辑', '删除选中', '添加'],
					hasButton: [],
					parent: '2'
				},
				{
					id: '25',
					name: '平台信息',
					router: '/home/plate',
					icon: 'reorder',
					isShow: true,
					button: ['编辑', '删除选中', '添加'],
					hasButton: [],
					parent: '2'
				},
				{
					id: '26',
					name: '快递公司管理',
					router: '/home/express',
					icon: 'reorder',
					isShow: true,
					button: ['编辑', '删除选中', '添加'],
					hasButton: [],
					parent: '2'
				}
			]
		},

		{
			id: '3',
			name: '商品管理',
			icon: 'el-icon-s-goods',
			isShow: true,
			children: [{
					id: '31',
					name: '商品类别',
					router: '/home/productLabel',
					icon: 'reorder',
					isShow: true,
					button: ['编辑', '删除选中', '添加'],
					hasButton: [],
					parent: '3'
				},
				{
					id: '32',
					name: '商品管理',
					router: '/home/product',
					icon: 'reorder',
					isShow: true,
					button: ['编辑', '删除选中', '添加', '商品规格','上架','下架','选中上架','选中下架'],
					hasButton: [],
					parent: '3'
				},
				{
					id: '35',
					name: '特卖商品',
					router: '/home/tproduct',
					icon: 'reorder',
					isShow: true,
					button: ['编辑', '删除选中', '添加', '商品规格'],
					hasButton: [],
					parent: '3'
				},
				{
					id: '33',
					name: '提货卡商品',
					router: '/home/card',
					icon: 'reorder',
					isShow: true,
					button: ['编辑', '删除选中', '添加'],
					hasButton: [],
					parent: '3'
				},
				{
					id: '36',
					name: '提货卡信息',
					router: '/home/cardInfo',
					icon: 'reorder',
					isShow: true,
					button: ['编辑', '删除选中', '添加','导入提货卡','恢复数据'],
					hasButton: [],
					parent: '3'
				},
				{
					id: '34',
					name: 'SKU管理',
					router: '/home/sku',
					icon: 'reorder',
					isShow: false,
					button: ['编辑', '删除选中', '添加', '返回'],
					hasButton: [],
					parent: '3'
				},
			]
		},

		{
			id: '4',
			name: '订单管理',
			icon: 'el-icon-s-order',
			isShow: true,
			children: [{
				id: '41',
				name: '订单管理',
				router: '/home/order',
				icon: 'reorder',
				isShow: true,
				button: ['编辑', '删除选中', '添加', '导出'],
				hasButton: [],
				parent: '4'
			},{
				id: '42',
				name: '提货卡订单',
				router: '/home/cardorder',
				icon: 'reorder',
				isShow: true,
				button: ['编辑', '删除选中', '添加', '导出'],
				hasButton: [],
				parent: '4'
			} ]
		},

		{
			id: '5',
			name: '流水管理',
			icon: 'el-icon-s-finance',
			isShow: true,
			children: [{
					id: '51',
					name: '支付流水',
					router: '/home/pay',
					icon: 'reorder',
					isShow: true,
					button: ['编辑', '删除选中', '添加'],
					hasButton: [],
					parent: '5'
				},
				{
					id: '52',
					name: '余额流水',
					router: '/home/balance',
					icon: 'reorder',
					isShow: true,
					button: ['编辑', '删除选中', '添加'],
					hasButton: [],
					parent: '5'
				},
				{
					id: '53',
					name: '积分流水',
					router: '/home/score',
					icon: 'reorder',
					isShow: true,
					button: ['编辑', '删除选中', '添加'],
					hasButton: [],
					parent: '5'
				},
				{
					id: '54',
					name: '提现管理',
					router: '/home/withdraw',
					icon: 'reorder',
					isShow: true,
					button: ['同意', '拒绝', '导出'],
					hasButton: [],
					parent: '5'
				},
			]
		},

		{
			id: '6',
			name: '详情管理',
			icon: 'el-icon-s-grid',
			isShow: false,
			children: [{
				id: '61',
				name: '商品详情',
				router: '/home/productpage',
				icon: 'reorder',
				isShow: true,
				button: ['编辑', '删除选中', '添加', '返回'],
				hasButton: [],
				parent: '6'
			}, ]
		},
	]
}

var cbs = {
	/**
	 * ajax请求成功，返回的状态码不是200时调用
	 * @param  {object} err 返回的对象，包含错误码和错误信息
	 */
	statusError(err) {
		console.log('err')
		if (err.status !== 404) {
			this.$message({
				showClose: true,
				message: '返回错误：' + err.msg,
				type: 'error'
			})
		} else {
			this.$store.dispatch('remove_userinfo').then(() => {
				this.$alert(err.status + ',' + err.msg + '！', '登录错误', {
					confirmButtonText: '确定',
					callback: action => {
						this.$router.push('/login')
					}
				})
			})
		}
	},

	/**
	 * ajax请求网络出错时调用
	 */
	requestError(err) {
		this.$message({
			showClose: true,
			message: '请求错误：' + (err.response ? err.response.status : '') + ',' + (err.response ? err.response.statusText : ''),
			type: 'error'
		})
	}
}

export {
	gbs,
	cbs
}



// WEBPACK FOOTER //
// ./src/config/settings.js